import {
  RulerHorizontalIcon,
  StretchHorizontallyIcon,
} from '@radix-ui/react-icons'
import { useGeckoAnalytics } from 'features/analytics'
import { useKestrel } from 'features/kestrelViewer'
import { useKestrelViewerContext } from 'features/kestrelViewer/types/KestrelViewerInterfaces'
import React, { useState } from 'react'
import styled from 'styled-components'

import { KestrelViewerTool } from './KestrelViewerTool'

const MeasurementModesContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`

const SubModesContainer = styled.div<{ $isVisible: boolean }>`
  position: absolute;
  left: 100%;
  top: 0;
  display: flex;
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  pointer-events: ${({ $isVisible }) => ($isVisible ? 'auto' : 'none')};
  transition: opacity 0.2s ease-in-out;
`

export const MeasurementModes: React.FC = () => {
  const {
    sendCommand,
    selectedMode,
    setSelectedMode,
    measurementType,
    setMeasurementType,
  } = useKestrelViewerContext()
  const { trackButtonClicked } = useGeckoAnalytics()
  const { kestrelModel } = useKestrel()
  const [showSubModes, setShowSubModes] = useState(false)

  const handleModeChange = (mode: string) => {
    setSelectedMode('measure')
    setMeasurementType(mode)
    sendCommand({ command: 'toggleMeasurementType', measurementType: mode })
    trackButtonClicked({
      button_name: `kestrel_set_measurement_mode`,
      kestrel_model_id: kestrelModel?.data.kestrel_model_id,
      measurement_type: mode,
    })
  }

  return (
    <MeasurementModesContainer
      onMouseEnter={() => setShowSubModes(true)}
      onMouseLeave={() => setShowSubModes(false)}>
      <KestrelViewerTool
        tooltipLabel={
          measurementType === 'straightLine'
            ? 'Measure 2 points'
            : 'Measure thickness'
        }
        tooltipSide='top'
        modeId='measure'
        selectedMode={selectedMode}
        measurementTypeId={measurementType}>
        {measurementType === 'straightLine' ? (
          <RulerHorizontalIcon width={25} height={25} />
        ) : (
          <StretchHorizontallyIcon width={25} height={25} />
        )}
      </KestrelViewerTool>

      <SubModesContainer $isVisible={showSubModes}>
        {measurementType !== 'straightLine' && (
          <KestrelViewerTool
            tooltipLabel={'Measure 2 points'}
            tooltipSide='top'
            modeId='measure'
            selectedMode={selectedMode}
            measurementTypeId='straightLine'
            onClick={() => handleModeChange('straightLine')}>
            <RulerHorizontalIcon width={25} height={25} />
          </KestrelViewerTool>
        )}
        {measurementType !== 'thickness' && (
          <KestrelViewerTool
            tooltipLabel={'Measure thickness'}
            tooltipSide='top'
            modeId='measure'
            selectedMode={selectedMode}
            measurementTypeId='thickness'
            onClick={() => handleModeChange('thickness')}>
            <StretchHorizontallyIcon width={25} height={25} />
          </KestrelViewerTool>
        )}
      </SubModesContainer>
    </MeasurementModesContainer>
  )
}
